export const INSTRUCTION_REDIRECT_URL = 'redirect_url';
export const INSTRUCTION_EMBEDDED = 'embedded_script';
export const INSTRUCTION_LRS = 'lrs_declaration';
